/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { arrayOf, object } from 'prop-types';
import mbpLogger from '@module-logger/mbp';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useUIDSeed } from 'react-uid';
import style from './ThreeUpColor.module.css';
import MessageStandard from '../../../../SubComponents/Message/MessageStandard';
import getBackgroundColor from '../../../../../../../helpers/getBackgroundColor';
import universalHandleClick from '../../../../UniversalHandleClick';

const ThreeUpColor = ({
    data, gaConstants, salesforceResponse,
}) => {
    useStyles(style);
    const isPresentationStyle = data?.swap_heading_position || false;
    const seed = useUIDSeed();
    const defaultParams = 'auto=webp';
    if (data.tile?.length) {
        const handleClick = universalHandleClick(salesforceResponse);
        const renderHeading = (heading) => <div className={`${style.heading} ${!isPresentationStyle ? style.paddingAdjust : ''}`}>{heading}</div>;
        return (
            <div className={style.container} data-testid="ThreeUpColor">
                {
                    data?.tile?.map(({
                        image, cta = {}, message = {}, styled_button = [],
                    }) => (
                        <div
                            key={seed(image)}
                            className={`${style.imageWrapper} ${!cta?.link?.href && !cta?.link?.title ? style.disableClick : ''}`}
                            style={{ background: getBackgroundColor(data.background_color) }}
                            role="presentation"
                            onClick={() => handleClick(cta, gaConstants)}
                            data-ga-category={cta?.tracking_event_category || gaConstants?.tracking_event_category}
                            data-ga-action={cta?.tracking_event_action || gaConstants?.tracking_event_action}
                            data-ga-label={cta?.tracking_event_label || gaConstants?.tracking_event_label}

                            data-banner-item-name={cta?.tracking_event_label || gaConstants?.tracking_event_label}
                            data-banner-type={cta?.tracking_event_action || gaConstants?.tracking_event_action}
                            data-banner-group={cta?.tracking_event_category || gaConstants?.tracking_event_category}
                            data-click-id="ThreeUpColor"
                            data-click-text="ThreeUpColor"
                        >
                            {message.heading && isPresentationStyle
                                && renderHeading(message.heading)}
                            <img className={style.image} src={`${image?.url}?${defaultParams}`} alt={image?.url.description} loading="lazy" />
                            {message.heading && !isPresentationStyle
                                && renderHeading(message.heading)}
                            <div className={style.messageBlock}>
                                <MessageStandard
                                    data={{
                                        content: {
                                            heading: { text: message?.content?.heading?.text, css_classes: message?.content?.heading?.css_classes },
                                            sub_heading: { text: message?.content?.sub_heading?.text, css_classes: message?.content?.sub_heading?.css_classes },
                                        },
                                        heading: '',
                                        sub_heading: message.sub_heading,
                                        message_position: {},
                                        styled_button,
                                        cta: {
                                            link: cta.link,
                                            theme: cta.theme,
                                            presentation: cta.presentation,
                                            tracking_event_category: gaConstants.tracking_event_category,
                                            tracking_event_action: gaConstants.tracking_event_action,
                                            tracking_event_label: cta.tracking_event_label,
                                        },
                                        has_background: false,
                                    }}
                                />
                            </div>
                        </div>
                    ),
                    )
                }
            </div>
        );
    }

    return mbpLogger.logError({
        appName: process.env.npm_package_name,
        component: 'Tiles/3up/ThreeUpColor/ThreeUpColor.js',
        message: 'No data available to render component',
    });
};

ThreeUpColor.propTypes = {
    data: arrayOf.isRequired,
    gaConstants: object.isRequired,
    salesforceResponse: object,
};
ThreeUpColor.defaultProps = {
    salesforceResponse: {},
};
export default ThreeUpColor;
